module.exports = __webpack_public_path__ + "img/img-intro-app-2-jp.9d9f13a8.svg";